export const BUTTON_VARIANTS = {
  CONTAINED: "contained",
  OUTLINED: "outlined",
  TEXT: "text"
};

export const BUTTON_SIZES = {
  SMALL: "small",
  SEMI_MEDIUM: "semi-medium",
  MEDIUM: "medium",
  SEMI_LARGE: "semi-large",
  LARGE: "large"
};

export const BUTTON_COLORS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  ERROR: "error"
};

export const ICON_COLOR_MODES = {
  FILL: "fill",
  STROKE: "stroke"
};
